export const attendeeBidsDetailsTabStyle = {
  wrapper: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    overflow: 'hidden',
  },

  tableContent: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    minHeight: 0,
    position: 'relative',
  },

  container: {
    padding: '0',
    marginBottom: '20px',
    flex: 1,
    overflow: 'auto',
  },

  pagination: {
    display: 'flex',
    justifyContent: 'flex-end',
    padding: '16px 0',
    flexShrink: 0,
    marginTop: 'auto',
  },

  loader: {
    position: 'absolute',
    left: '50%',
    top: '50%',
    transform: 'translate(-50%, -50%)',
  },
  search: {
    '& .MuiTextField-root': {
      width: '400px',
    },
  },

  table: {
    maxWidth: '1075px',
    tableLayout: 'fixed',
  },

  tableHeader: {
    '& > :nth-of-type(1)': {
      textTransform: 'capitalize',
      width: '9%',
    },
    '& > :nth-of-type(2)': {
      paddingLeft: '60px !important',
      width: '41%',

      '@media (max-width: 1199.98px)': {
        width: '29%',
      },
    },
    '& > :nth-of-type(3)': {
      width: '6%',

      '@media (max-width: 1199.98px)': {
        width: '12%',
      },
    },
    '& > :nth-of-type(4)': {
      width: '9%',

      '@media (max-width: 1199.98px)': {
        width: '12%',
      },
    },
    '& > :nth-of-type(5)': {
      width: '19%',
    },
    '& > :nth-of-type(6)': {
      width: '9%',

      '@media (max-width: 1199.98px)': {
        width: '12%',
      },
    },
    '& > :nth-of-type(7)': {
      width: '8%',
    },
  },

  tableBody: {
    '& > :nth-of-type(2)': {
      '&.MuiTableCell-body .MuiTypography-root': {
        '&.MuiTypography-subtitle1': {
          fontWeight: 700,
        },
        '&.MuiTypography-caption': {
          color: 'var(--neutral-300)',
        },
      },
    },

    '& > :nth-of-type(5)': {
      '&.MuiTableCell-body .MuiTypography-root': {
        '&.MuiTypography-subtitle2': {
          fontWeight: 700,
        },
        '&.MuiTypography-caption': {
          color: 'var(--neutral-300)',
        },
      },
    },

    '& > :nth-of-type(6)': {
      fontSize: '16px',
      fontWeight: 700,
    },

    '& .MuiTableCell-root': {
      textOverflow: 'ellipsis',
      overflow: 'hidden',
      height: '42px',
      paddingTop: '8px !important',
      paddingBottom: '8px !important',
    },
  },

  bodyCell: {
    display: 'flex',
    gap: '12px',
  },

  bodyCellImage: {
    marginLeft: '-8px',
  },

  bodyCellImageContent: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  },
};
